import React from "react";
import { C, FONT } from "./ui";

const WARNA = ["#e9731c", "#2563eb", "#2e9e5b", "#7c3aed", "#d9467a", "#0f9ba8", "#b7791f", "#5c6b7a"];
export const warnaDari = s => WARNA[[...(s || "")].reduce((a, ch) => a + ch.charCodeAt(0), 0) % WARNA.length];
export const inisial = w => ((w?.nama || w?.ig_username || "?").trim().split(/\s+/).slice(0, 2).map(x => x[0]).join("") || "?").toUpperCase();

// Waktu singkat ala kotak masuk: baru · 5m · 4j · 2h · 12 Okt
export const waktuSingkat = iso => {
  if (!iso) return "";
  const d = new Date(iso), diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "baru";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}j`;
  if (diff < 7 * 86400) return `${Math.floor(diff / 86400)}h`;
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "short" });
};

// Lingkaran inisial berwarna (warna dari username)
export function Inisial({ w, size = 42 }) {
  return <span aria-hidden style={{ width: size, height: size, borderRadius: 99, background: warnaDari(w?.ig_username), color: "#fff", display: "grid", placeItems: "center", fontWeight: 800, fontSize: Math.round(size * 0.36), flex: "none", letterSpacing: .3 }}>{inisial(w)}</span>;
}

// Satu baris percakapan: inisial · @username · status teman · cuplikan · waktu · titik belum dibaca
export function BarisPercakapan({ p, onClick }) {
  const baru = p.belum_dibaca > 0;
  return (
    <button data-testid={`surat-percakapan-${p.warga.ig_username}`} onClick={onClick}
      style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", padding: "10px 2px", border: 0, borderTop: `1px solid ${C.line}`, background: "transparent", cursor: "pointer", textAlign: "left", fontFamily: FONT, color: C.ink }}>
      <Inisial w={p.warga} />
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: "flex", alignItems: "baseline", gap: 6, minWidth: 0 }}>
          <b style={{ fontSize: 13.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>@{p.warga.ig_username}</b>
          <span style={{ fontSize: 11, color: p.teman ? "#189a5b" : C.sub, fontWeight: 600, whiteSpace: "nowrap" }}>· {p.teman ? "teman" : p.minta === "masuk" ? "ingin berteman" : "belum teman"}</span>
        </span>
        <span data-testid={`surat-cuplikan-${p.warga.ig_username}`} style={{ display: "block", fontSize: 12.5, color: baru ? C.ink : C.sub, fontWeight: baru ? 700 : 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: 2 }}>{p.terakhir.dari_saya ? "Kamu: " : ""}{p.terakhir.teks}</span>
      </span>
      <span style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 5, flex: "none" }}>
        <span style={{ fontSize: 11, color: C.sub, fontWeight: 600 }}>{waktuSingkat(p.terakhir.created_at)}</span>
        {baru && <span data-testid={`surat-belum-${p.warga.ig_username}`} style={{ minWidth: 18, height: 18, padding: "0 5px", borderRadius: 99, background: C.blue, color: "#fff", fontSize: 10, fontWeight: 800, display: "grid", placeItems: "center" }}>{p.belum_dibaca}</span>}
      </span>
    </button>
  );
}

// Gelembung surat: milikku biru di kanan, lawan krem di kiri
export function Gelembung({ p }) {
  return (
    <div data-testid={`surat-gelembung-${p.id}`} style={{ display: "flex", justifyContent: p.dari_saya ? "flex-end" : "flex-start", marginTop: 6 }}>
      <div style={{ maxWidth: "78%", padding: "9px 12px", borderRadius: p.dari_saya ? "16px 16px 4px 16px" : "16px 16px 16px 4px", background: p.dari_saya ? C.blue : C.cream, color: p.dari_saya ? "#fff" : C.ink, fontSize: 13.5, lineHeight: 1.45, wordBreak: "break-word" }}>
        {p.teks}
        <span style={{ display: "block", fontSize: 10, opacity: .7, marginTop: 3, textAlign: "right" }}>{waktuSingkat(p.created_at)}{p.dari_saya ? (p.dibaca ? " · dibaca" : "") : ""}</span>
      </div>
    </div>
  );
}

// Baris warga di tab Teman (permintaan / teman) dengan tombol aksi di kanan
export function BarisWarga({ w, sub, aksi, onClick, testid }) {
  return (
    <div data-testid={testid} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 2px", borderTop: `1px solid ${C.line}` }}>
      <button onClick={onClick} style={{ display: "flex", alignItems: "center", gap: 12, flex: 1, minWidth: 0, border: 0, background: "transparent", padding: 0, cursor: "pointer", textAlign: "left", fontFamily: FONT, color: C.ink }}>
        <Inisial w={w} size={38} />
        <span style={{ minWidth: 0 }}><b style={{ display: "block", fontSize: 13.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>@{w.ig_username}</b><span style={{ fontSize: 11.5, color: C.sub }}>{sub}</span></span>
      </button>
      <span style={{ display: "flex", gap: 6, flex: "none" }}>{aksi}</span>
    </div>
  );
}

export const tombolKecil = (tid, label, onClick, utama = false) => (
  <button key={tid} data-testid={tid} onClick={onClick} style={{ height: 32, padding: "0 12px", borderRadius: 99, border: utama ? 0 : `1px solid ${C.line}`, background: utama ? C.blue : "#fff", color: utama ? "#fff" : C.ink, fontWeight: 800, fontSize: 12, cursor: "pointer", fontFamily: FONT, whiteSpace: "nowrap" }}>{label}</button>
);
